import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DemoPage from './pages/DemoPage';
import BlogsPage from './pages/BlogsPage';
import LoginPageSimple from './pages/LoginPageSimple';
import RegisterPageSimple from './pages/RegisterPageSimple';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import OnboardingWizard from './pages/OnboardingWizard';
import AgencyOnboarding from './pages/AgencyOnboarding';
import TrialActivation from './pages/TrialActivation';
import SubscriptionSelection from './pages/AllPlansProfessional';
import Dashboard from './pages/Dashboard';
import SEODashboard from './pages/SEODashboard';
import BrandsPage from './pages/BrandsPage';
import ContentPage from './pages/ContentPage';
import MediaLibrary from './pages/MediaLibrary';
import SubscriptionPage from './pages/AllPlansProfessional';
import Plans from './pages/AllPlansProfessional';
import IntegrationsPage from './pages/IntegrationsPage';
import AdminApprovalsPage from './pages/AdminApprovalsPage';
import AIContentGenerator from './pages/AIContentGenerator';
import SocialMediaManager from './pages/SocialMediaManager';
import MetaDemoPage from './pages/MetaDemoPage';
import ForgotPassword from './pages/ForgotPassword';
import SettingsPage from './pages/SettingsPage';
import AboutUs from './pages/AboutUs';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicyNew';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import AcceptableUse from './pages/AcceptableUse';
import DataDeletion from './pages/DataDeletion';
import AuthPage from './pages/AuthPage';
import FAQPage from './pages/FAQPage';
import HelpCenter from './pages/HelpCenter';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import SEOGuidePage from './pages/SEOGuidePage';
import TutorialsPage from './pages/TutorialsPage';
import BlogPage from './pages/BlogPage';
import { Toaster } from './components/ui/sonner';
import OnboardingGate from './components/OnboardingGate';
import authService from './utils/authService';
import './App.css';

const PrivateRoute = ({ children }) => {
  return authService.isAuthenticated() ? children : <Navigate to="/login" replace />;
};

const ProtectedRoute = ({ children }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <OnboardingGate>{children}</OnboardingGate>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/seo-guide" element={<SEOGuidePage />} />
          <Route path="/tutorials" element={<TutorialsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPage />} />
          <Route path="/login" element={<LoginPageSimple />} />
          <Route path="/register" element={<RegisterPageSimple />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/onboarding" element={<OnboardingWizard />} />
          <Route
            path="/agency-onboarding"
            element={
              <PrivateRoute>
                <AgencyOnboarding />
              </PrivateRoute>
            }
          />
          <Route
            path="/trial-activation"
            element={
              <PrivateRoute>
                <TrialActivation />
              </PrivateRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <PrivateRoute>
                <SubscriptionSelection />
              </PrivateRoute>
            }
          />
          <Route
            path="/plans"
            element={
              <PrivateRoute>
                <Plans />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seo-dashboard"
            element={
              <ProtectedRoute>
                <SEODashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-content"
            element={
              <ProtectedRoute>
                <AIContentGenerator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/social-media"
            element={
              <ProtectedRoute>
                <SocialMediaManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brands"
            element={
              <ProtectedRoute>
                <BrandsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/content"
            element={
              <ProtectedRoute>
                <ContentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute>
                <MediaLibrary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute>
                <SubscriptionPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/integrations"
            element={
              <PrivateRoute>
                <IntegrationsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/approvals"
            element={
              <PrivateRoute>
                <AdminApprovalsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blog/:slug" element={<BlogsPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/acceptable-use" element={<AcceptableUse />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/signup" element={<AuthPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/meta-demo" element={<MetaDemoPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
